import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceStatusEnum, PaymentMethodEnum } from "../../data/enums";
import { paymentMethods } from "../../data/payment.data";

export namespace FinanceInvoiceValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(InvoiceStatusEnum.values)),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            recipient: baseVals.string(),
            dueDate: baseVals.isoDate("Tanggal Jatuh Tempo"),
            discount: v.optional(baseVals.intMin(0, "Diskon")),
            notes: v.optional(baseVals.string()),
            items: v.array(
                v.object({
                    name: baseVals.string(),
                    price: v.number(),
                    discount: v.number(),
                    quantity: v.number(),
                    tax: v.optional(v.number()),
                }),
            ),
        }),
    );

    export const Payment = defineValidation(
        v.object({
            method: v.picklist(PaymentMethodEnum.values),
            account: baseVals.string(),
            notes: v.optional(baseVals.string()),
        }),
    );

    export namespace API {
        export const CreatePayment = defineValidation(
            v.object({
                paymentMethod: v.pipe(v.string(), v.picklist(paymentMethods)),
            }),
        );
    }
}
